import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Klassenavne med korrekt Tailwind-konfliktopløsning. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
